import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import useAppStore from "../../store/global";

export default function Paginator({ pageNum, setPageNum, totalPages }) {
  const [value, setValue] = useState(pageNum);
  const {isChanged}=useAppStore()
  const handlePageChange = (page) => {
    setPageNum(page);
  };
useEffect(()=>{
 setValue(pageNum)
},[isChanged])
  return (
    <div className="d-flex justify-content-end align-items-center">
      <Pagination>
        <Pagination.First
          onClick={() => {handlePageChange(1)
            setValue(Number(1))
          }}
          disabled={pageNum === 1}
        />
        <Pagination.Prev
          onClick={() => {
            handlePageChange(pageNum - 1)
            setValue(Number(pageNum-1))
          }}
          disabled={pageNum === 1}
        />
        <Pagination.Item disabled>Page</Pagination.Item>

        <Pagination.Item>
          <input
            type="text"
            name=""
            onBlur={(e) => {
              if (Number(e.target.value )> totalPages) {
                setPageNum(totalPages);
                setValue(totalPages);
              } else {
                setPageNum(Number(e.target.value));
              }
            }}
            onChange={(e) => {
              setValue((e.target.value));
            }}
            value={value}
            style={{
              maxWidth: "25px",
              zIndex: 1,
              maxHeight: "20px",
              border: "none",
              outline: "none",
            }}
          />
        </Pagination.Item>
        <Pagination.Item disabled>of {totalPages}</Pagination.Item>
        <Pagination.Next
          onClick={() => {
            handlePageChange(pageNum + 1)
            setValue(Number(pageNum+1))
          }}
          disabled={pageNum === totalPages}
        />
        <Pagination.Last
          onClick={() =>{ handlePageChange(totalPages)
            setValue(totalPages)
          }}
          disabled={pageNum === totalPages}
        />
      </Pagination>
    </div>
  );
}
